import * as els from './articleListedElements';
import * as handlers from './articleListedHandlers';

export const articleListedSwiper = (): void => {
  let touchStartX: number | null = null;
  const touchSensitivity = 9; // Citlivost na pohyb prstu

  els.article.addEventListener('touchstart', (e: TouchEvent) => {
    touchStartX = e.touches[0].clientX;
  });

  els.article.addEventListener('touchmove', (e: TouchEvent) => {
    if (touchStartX === null) return;
    const touchEndX = e.touches[0].clientX;
    const swipeWidthX = touchEndX - touchStartX;

    if (swipeWidthX > touchSensitivity) {
      // Přechod na předchozí kapitolu
      handlers.prev();
    } else if (swipeWidthX < -touchSensitivity) {
      // Přechod na další kapitolu
      handlers.next();
    }

    touchStartX = null;
  });
};
